import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { NPrivacyState, PrivacyStateService } from '@df/core/meta/privacy-state.service';
import { AbService } from '@df/module-ab/ab.service';

@Injectable({
    providedIn: 'root'
})
export class AbServiceDecorator extends AbService {
    private privacyStateService = inject(PrivacyStateService);
    protected window = inject(DOCUMENT).defaultView as Window & typeof globalThis;

    protected override async loadConvert() {
        const gen = this.abConfig.convertcom?.script;
        const script = gen && gen(this.app);

        const load = async () => {
            if (script) {
                await this.request.loadScriptAsync(script, {
                    onScript: el => el.setAttribute('class', 'optanon-category-C0002')
                });
                this.updateConvertExperiments();
                this.app.meta.subscribe(() => {
                    window['_conv_q'] = window['_conv_q'] || [];
                    window['_conv_q'].push(['run', 'true']);
                    this.updateConvertExperiments();
                });
            }
        };

        const canLoad = () => this.privacyStateService.getState(NPrivacyState.Area.performance).value;
        const listener = () => {
            if (canLoad()) {
                this.window.removeEventListener('OneTrustGroupsUpdated', listener);
                load();
            }
        };
        if (canLoad()) {
            await load();
        } else {
            this.window.addEventListener('OneTrustGroupsUpdated', listener);
        }
    }
}
